module.exports = __webpack_public_path__ + "img/35_44.349782ca.png";